import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { AuthService } from '../../service/auth.service';
import { HttpAgentService } from '../../service/http-agent.service';
import { finalize } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NzMessageService } from 'ng-zorro-antd/message';

export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	return control.value.password === control.value.confirmPassword
		? null
		: { PasswordNoMatch: true };
};

@Component({
	selector: 'app-agent-change-password',
	standalone: false,
	templateUrl: './agent-change-password.component.html',
	styleUrl: './agent-change-password.component.scss'
})
export class AgentChangePasswordComponent {
	form!: FormGroup;
	submitting: boolean = false;
	showCurrentPassword = false;
	showPassword = false;
	showConfirmPassword = false;
	message?: string;

	constructor(private authService: AuthService, private messageService: NzMessageService, private modelRef: NgbActiveModal, private agentService: HttpAgentService, private fb: FormBuilder) {

	}

	ngOnInit(): void {
		this.form = this.fb.group({
			currentPassword: ['', [Validators.required, Validators.minLength(4)]],
			password: ['', [Validators.required, Validators.minLength(4)]],
			confirmPassword: ['', [Validators.required]]
		},
			{ validators: confirmPasswordValidator }
		);
	}

	onSubmit() {
		this.submitting = true;
		this.agentService.doChangePassword(this.form.value).pipe(
			finalize(() => this.submitting = false)
		)
			.subscribe(result => {
				if (result.success == false) {
					this.message = result.message;
				} else {
					this.messageService.info("Password updated");
					this.modelRef.close();
				}
			});
	}
	isInvalid(field: string): boolean {
		return !!(this.form.get(field)?.invalid && this.form.get(field)?.touched);
	}
	goBack() {
		this.modelRef.close();
	}
	get showPasswordsDontMatchLabel(): boolean {
		if (this.form.get('password')!.touched == false) {
			return false;
		}
		if (this.form.get('confirmPassword')!.touched == false) {
			return false;
		}
		const password = this.form.get('password')!.value;
		const confirmPassword = this.form.get('confirmPassword')!.value;

		return password != confirmPassword;
	}
}
